<div class="edit-container">
  <div class="header">
    <div class="left-info">
      <i class="mdi mdi-script-text-outline scrip_icon"></i>
      <span class="multi-step-title" *ngIf="!data.editMode"><b>Add script</b></span>
      <span class="multi-step-title" *ngIf="data.editMode"
        ><b>Edit script</b> -
        {{ data.precheckVersionName ? data.precheckVersionName : data.scriptName }}</span
      >
    </div>
    <div class="action">
      <div class="action-label" [ngClass]="{ disabled: isEmptyScript() }">
        <i class="mdi mdi-content-copy"></i>
        <span
          class="multi-step-title"
          [cdkCopyToClipboard]="editorValue"
          (click)="copyEditorValue()"
          >Copy</span
        >
      </div>
      <div class="action-label" [ngClass]="{ disabled: isEmptyScript() }">
        <i class="mdi mdi-content-save-outline"></i>
        <span class="multi-step-title" (click)="SaveOrPrecheckScript()">Save/Precheck</span>
      </div>
      <i class="mdi mdi-window-close" (click)="onCloseIcon()"></i>
    </div>
  </div>
  <code-editor [data]="model"></code-editor>
</div>
